import React from 'react';
import {
  tenantAppStoreAppUrl,
  tenantGooglePlayAppUrl,
} from '../../../constants/literals';
import { gaNewDownloadApp } from '../../../services/analitics';
import { appSelector, linkTarget, os } from '../../../utils/deviceUtils';
import { Message } from '../message/message';
import './index.scss';

export const AppDownload = () => {
  const url = appSelector(tenantGooglePlayAppUrl, tenantAppStoreAppUrl);

  return (
    <div className={'app-download__wrapper zds-body-s-highlight'}>
      <a href={url} target={linkTarget} onClick={() => gaNewDownloadApp(os)}>
        <Message tag="p" id={'store.download.app'} className={'app-download'} />
      </a>
    </div>
  );
};
